import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
  duration: number;
}

export interface ToastsState {
  toasts: Toast[];
}

const initialState: ToastsState = {
  toasts: []
};

// Default durations based on toast type
const DEFAULT_DURATIONS: Record<ToastType, number> = {
  success: 3000,
  info: 3000,
  error: 5000,
  warning: 5000
};

const toastsSlice = createSlice({
  name: 'toasts',
  initialState,
  reducers: {
    addToast: {
      reducer: (state, action: PayloadAction<Toast>) => {
        state.toasts.push(action.payload);
      },
      prepare: (message: string, type: ToastType = 'info', duration?: number) => {
        const id = uuidv4();
        const finalDuration = duration ?? DEFAULT_DURATIONS[type];

        return {
          payload: {
            id,
            message,
            type,
            duration: finalDuration
          }
        };
      }
    },
    removeToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter(toast => toast.id !== action.payload);
    }
  }
});

export const { addToast, removeToast } = toastsSlice.actions;

export default toastsSlice.reducer;
